module.exports = __webpack_public_path__ + "static/media/dekentje14.85816816.jpg";